var exports = {
  "k": "xae11d333--0b2e8f--container",
  "M": "xae11d333--0b2e8f--slide",
};

module.exports = exports;
